import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const eventId = Sentry.captureException(error, { extra: info });
    this.setState({ eventId });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh',
          background: '#0a1929', color: 'white', gap: '1rem', padding: '2rem', textAlign: 'center'
        }}>
          <div style={{ fontSize: '3rem' }}>⚠️</div>
          <h2 style={{ margin: 0, fontSize: '1.4rem' }}>Щось пішло не так</h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', margin: 0 }}>
            Спробуйте оновити сторінку. Якщо помилка повторюється — зверніться до підтримки.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '0.5rem', padding: '0.6rem 1.6rem',
              background: '#5F9598', border: 'none', borderRadius: '8px',
              color: 'white', fontSize: '1rem', cursor: 'pointer'
            }}
          >
            Оновити сторінку
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
